'use client'

import { ErrorPage } from '#components/error/error-page.tsx'

function NotFoundPage() {
  return <ErrorPage code={404} />
}

export default NotFoundPage
